import React from "react";

const CampaignHeader = ({ formData, errors, handleChange, handleSubmit }) => {
  return (
    <div className="campaign-header bg-white p-4 rounded-3 shadow-sm mb-4 border-0">
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div className="d-flex align-items-center flex-grow-1 me-3" style={{ maxWidth: "600px" }}>

          <div className="flex-grow-1 ms-3 position-relative">
            <input
              className={`form-control form-control-lg border-0 px-3 py-2 campaign-name-input ${
                errors.campaignName ? "is-invalid" : ""
              }`}
              placeholder="Enter Campaign name here"
              name="campaignName"
              value={formData.campaignName}
              onChange={handleChange}
              style={{ 
                backgroundColor: "#f8f9fa", 
                fontSize: "1.25rem",
                fontWeight: "500",
                borderRadius: "12px"
              }}
            />
            {errors.campaignName && (
              <div className="invalid-feedback position-absolute mt-1">
                {errors.campaignName}
              </div>
            )}
          </div>
        </div>
        
        <div className="d-flex gap-2 flex-wrap">
          <button 
            className="btn btn-outline-secondary d-flex align-items-center"
            style={{ borderRadius: "8px" }}
          >
            <i className="bi bi-file-earmark me-2"></i>
            Save Draft
          </button>
          <button 
            className="btn btn-primary d-flex align-items-center campaign-live-btn"
            onClick={handleSubmit}
            style={{ 
              borderRadius: "8px",
              padding: "0.5rem 1.5rem",
              fontWeight: "600"
            }}
            disabled={!formData.campaignName.trim()}
          >
            <i className="bi bi-send-check me-2"></i>
            Set Live
          </button>
        </div>
      </div>  
    </div>
  );
};

export default CampaignHeader;